module.exports = __webpack_public_path__ + "img/1.14e19bd5.jpg";